module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAwBAMAAAD5pqeQAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAhUExURUxpcfDhwO/fv+/fv/DhwPDhwO/fv/DhwPHkwe/fv/DhwM8lL7EAAAAKdFJOUwDfIBDP7zCQX2ARJfTlAAAAZElEQVQoz2NgoBwwKyBxTISQJLwWIqRMVq1CSCmuWoWQYpIiV0oYLpW6atUSAxiHLWrVKmdqSxXApWatWhUA53QhcdhWISlDNgDFaMokULyNHCAoQUWUBGqUoEQWSjSiRjBlAAC55UWrHoQnJwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images_member/per1 (52).png
// module id = Zuzd
// module chunks = 1